import * as React from 'react';
import * as advance from "./style.module.scss";
import { AdvanceRocket } from "../../../../AdvanceRocket";
import { ExpertLicenses } from "../../../../ExpertLicenses";
import { Licenses } from "../../../../Licenses";
export const Advance = () => {
  return (
    <>
      <AdvanceRocket/>
      <section className={`${advance.advance} ${advance.experts}`}>
        <div className="container">
          <h2>Нас ценят эксперты образования</h2>
          <ExpertLicenses navColor={"#FE4C04"}/>
        </div>
      </section>
      <section className={advance.advance}>
        <div className="container">
          <h2>Мы развиваем образование</h2>
          <Licenses navColor={"#FE4C04"}/>
        </div>
      </section>
    </>
  );
};
